import React from "react";
import {Paper} from "@mui/material";
import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles"
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import CommonCssStyles from "../../../../css/CommonCssStyles";
import LabelsGrid from "./grid/LabelsGrid";
import {LabelsTranslationKey} from "./LabelsTranslationKey";
import {_transl} from "../../../../store/localization/TranslMessasge";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        page: CommonCssStyles.getRootPageStyles(theme),
        headerPageSegment: CommonCssStyles.getHeaderPageSegmentStyles(theme),
        controlPageSegment: CommonCssStyles.getControlPageSegmentStyles(theme),
    })
);

export default function LabelsPage() {

    const classes = useStyles();

    return (
        <Paper className={classes.page}>
            <div className={classes.headerPageSegment}>
                <Typography variant="h6">
                    {_transl(LabelsTranslationKey.TITLE)}
                </Typography>
            </div>
            <Divider/>
            <Divider/>
            <div className={classes.controlPageSegment}>
                <LabelsGrid/>
            </div>
        </Paper>
    )
}
